import axios, { AxiosError } from "axios"
import { TAX_PLAN_SUPPLIER_PATH, SUPPLIER_PATH } from "../../constants/paths"
import {
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials,
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
} from "interceptors"

const instance = axios.create({
  baseURL: process.env.REACT_APP_CONFIGURATION_API_SERVICE_DOMAIN,
})
instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

export const getTaxPlanSupplierBySupplierIdService = async (id: any) => {
  try {
    const result = await instance.get(
      TAX_PLAN_SUPPLIER_PATH + SUPPLIER_PATH + `/${id}`
    )
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const createTaxPlanSupplier = async (taxPlaSupplier: any) => {
  try {
    const result = await instance.post(TAX_PLAN_SUPPLIER_PATH, taxPlaSupplier)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const deleteTaxPlanSupplier = async (id: any) => {
  try {
    const result = await instance.delete(TAX_PLAN_SUPPLIER_PATH + `/${id}`)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}
